import script from "./orderManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./orderManagement.vue?vue&type=script&setup=true&lang=js"

import "./orderManagement.vue?vue&type=style&index=0&id=1076b7f8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1076b7f8"]])

export default __exports__